import { defineComponent as _defineComponent } from 'vue'
import { Ref, ref, watch, onMounted } from 'vue';

import { useRealtimeReportStore } from '@/stores';
import { SelectOptionsService } from '@/services';
import { toastServiceError } from '@/services/core/notification';

import { RealtimeReportFilter, SelectOptionsServiceGetQueuesResult } from '@/types';

import { FilterIcon } from '@heroicons/vue/solid';


export default /*@__PURE__*/_defineComponent({
  __name: 'RealtimeReportFilters',
  setup(__props, { expose: __expose }) {
  __expose();

const filterOpened = ref(false);
const realtimeReportStore = useRealtimeReportStore();

const filters: Ref<RealtimeReportFilter> = ref({
    queues: realtimeReportStore.defaultFilter.queues,
});

watch(filterOpened, () => {
    refreshLocalFilter();
});

const queueOptions = ref<SelectOptionsServiceGetQueuesResult[]>([]);
const fetchQueues = async () => {
    try {
        const { data } = await SelectOptionsService.getQueues();
        queueOptions.value = data;
    } catch (error) {
        toastServiceError(error);
    }
};

const applyFilters = () => {
    realtimeReportStore.applyFilters(filters.value);
};

const clearFilters = () => {
    realtimeReportStore.clearFilter();
    refreshLocalFilter();
};

const refreshLocalFilter = () => {
    filters.value.queues = realtimeReportStore.filter.queues;
};

onMounted(() => {
    fetchQueues();
});

const __returned__ = { filterOpened, realtimeReportStore, filters, queueOptions, fetchQueues, applyFilters, clearFilters, refreshLocalFilter, get FilterIcon() { return FilterIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})